import React, { Component } from 'react';
import {Link} from 'react-router-dom';

class TopBar extends Component {
    render() {
        return (
            <></>
            // <div id="top-bar">
            //     <div id="top-bar-inner" className="container">
            //         <div className="top-bar-inner-wrap">
            //             <div className="top-bar-content">
            //                 <div className="inner">
            //                     {/* <span className="address content">Namık Kemal Mahallesi Esenyurt / İstanbul </span> */}
            //                     <span className="phone content">0530 244 87 89 - 0545 837 70 75</span>
            //                     <span className="time content">Pazartesi - Cumartesi: 08.00 - 18.00</span>
                    
            //                 </div>                            
            //             </div>
            //             {/* <div className="top-bar-socials">
            //                 <div className="inner">
            //                     <span className="text">Bizi Takip Edin:</span>
            //                     <span className="icons">
            //                         <Link to="#"><i className="fa fa-facebook" /></Link>
            //                         <Link to="#"><i className="fa fa-twitter" /></Link>
            //                         <Link to="#"><i className="fa fa-pinterest-p" /></Link>
            //                         <Link to="#"><i className="fa fa-rss" /></Link>
            //                     </span>
            //                 </div>
            //             </div> */}
            //         </div>                    
            //     </div>
            // </div>
        );
    }
}

export default TopBar;